import {MutationTree} from "vuex";
import {RoutingState} from "@service/store/types/RoutingState";
import {RoutingFrom} from "@service/types/RoutingFrom";

export const mutations: MutationTree<RoutingState> = {
    add(state, item: RoutingFrom) {
        state.froms.push(item);
    },
    remove(state, index) {
        state.froms.splice(index, 1);
    }
}